import React from "react";
import { Search } from "lucide-react";

export function AdminFilterBar({ children }) {
  return <div className="rounded-2xl bg-white border border-[#E5DFC8] p-4 flex items-center gap-3 flex-wrap">{children}</div>;
}

export function AdminSearchInput({ value, onChange, placeholder, testId }) {
  return (
    <div className="relative flex-1 min-w-[220px]">
      <Search className="absolute start-4 top-1/2 -translate-y-1/2 text-hv-slate" size={16} />
      <input
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        data-testid={testId}
        className="w-full ps-10 pe-4 h-10 rounded-full border border-[#E5DFC8] bg-hv-cream focus:outline-none focus:border-hv-teal text-sm font-medium"
      />
    </div>
  );
}

export function AdminFilterSelect({ label, value, onChange, children, testId }) {
  return (
    <label className="inline-flex items-center gap-1.5 h-10 rounded-full border border-[#E5DFC8] bg-white px-4 text-sm text-hv-navy cursor-pointer">
      {label && <>{label}:</>}
      <select value={value} onChange={onChange} data-testid={testId} className="bg-transparent outline-none font-semibold cursor-pointer">
        {children}
      </select>
    </label>
  );
}

// Segmented control — used both as a filter (status/period) and as a tab
// bar (Inbox, editor Content/Translations). Active segment fills solid,
// inactive stays muted with a hover tint.
export function AdminSegmentedControl({ options, value, onChange, testId }) {
  return (
    <div className="inline-flex max-w-full overflow-x-auto items-center rounded-full border border-[#E5DFC8] bg-white p-1 gap-1" data-testid={testId}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          data-testid={testId ? `${testId}-${opt.value}` : undefined}
          className={`rounded-full px-3.5 py-1.5 text-sm font-medium transition inline-flex items-center gap-1.5 ${
            value === opt.value ? "bg-hv-coral text-white" : "text-hv-slate hover:text-hv-navy"
          }`}
        >
          {opt.icon && <opt.icon size={14} strokeWidth={2.5} />}
          {opt.label}
          {!!opt.count && (
            <span className={`rounded-full text-[10px] px-1.5 py-0.5 ${value === opt.value ? "bg-white text-hv-coral" : "bg-hv-coral text-white"}`}>
              {opt.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
